import { render, staticRenderFns } from "./FormInputRating.vue?vue&type=template&id=655ab568&"
import script from "./FormInputRating.vue?vue&type=script&lang=js&"
export * from "./FormInputRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655ab568')) {
      api.createRecord('655ab568', component.options)
    } else {
      api.reload('655ab568', component.options)
    }
    module.hot.accept("./FormInputRating.vue?vue&type=template&id=655ab568&", function () {
      api.rerender('655ab568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputRating.vue"
export default component.exports